<template>
  <BlockRepeater
    v-slot="slotProps"
    class="BuyingOrder"
    title=""
    label="Voeg een inkooporder toe"
    :path="path"
    :values="values"
    :disabled="disabled"
    :deleted="evaluateDeletedState"
  >
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :layout="layout"
      :validation="validation"
      :disabled="disabled"
      :path="`${path}.${slotProps.id}`"
      :viewer="viewer"
    />
  </BlockRepeater>
</template>

<script>
import BlockRepeater from '@/components/form/BlockRepeater'
import FieldSet from '@/components/form/FieldSet'

import { helpers } from 'vuelidate/lib/validators'
import { isUrl } from '@/services/validation'

export default {
  name: 'BuyingOrder',
  components: { BlockRepeater, FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'Party',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'PartyName': {
          'type': 'string',
          'title': 'Leverancier',
          'readonly': true,
        },
        'LinkToBuyingOrder': {
          'type': 'string',
          'format': 'url',
          'title': 'Link naar inkooporder',
        },
        'OrderedDate': {
          'type': 'string',
          'format': 'date',
          'title': 'Datum waarop de order is geplaatst',
        },
        'deleted_at': {
          type: 'hidden',
        },
      },
      layout: [{
        'columns': '1fr 1fr',
        'fields': ['PartyName', 'OrderedDate'],
      }, {
        'columns': '1fr 0px',
        'fields': ['LinkToBuyingOrder', 'deleted_at'],
      }],
      validation: {
        LinkToBuyingOrder: {
          isUrl: (value) => !helpers.req(value) || isUrl(value),
        },
      },
    }
  },
  methods: {
    evaluateDeletedState({ index }) {
      return !! (
        this.values[this.path] && this.values[this.path][index] && this.values[this.path][index].deleted_at
      )
    },
  },
}
</script>
